<template>
  <v-card>
    <v-container fluid class="pt-2 pb-2">
      <v-row dense>
        <v-col cols="12" md="5" offset-md="2">
          <v-row dense>
            <v-col cols="4">
              <v-chip
                text-color="white"
                small
                class="toolbar__title red darken-2"
                style="width:100%"
              >
                <b>Empty Coils</b>
              </v-chip>
            </v-col>
            <v-col cols="8">
              <v-chip v-if="isMultipleLocation"
                text-color="white"
                small
                class="toolbar__title"
                :color="locationData.color + ' darken-2'"
                style="width:100%"
              >
                <b>{{locationData.ssh_port}} - {{locationData.name}}</b>&nbsp;
                <router-link
                  :to="{ name: 'Location', params: { id: locationData.id }}"
                  target="_blank"
                  @click.native.stop=""
                  class="icon-link"
                >
                  <v-icon small color="white">mdi-open-in-new</v-icon>
                </router-link>
              </v-chip>
            </v-col>
          </v-row>
          <coil-table
            :product="product"
            :locationData="locationData"
            :allProducts="allProducts"
          ></coil-table>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import CoilTable from '@/components/Common/Rental/Locations/Products/LocationProduct/CoilTable'

  export default {
    props: {
      coils: Array,
      locationData: Object,
      isMultipleLocation: Boolean,
      allProducts: Array
    },

    components: {
      CoilTable
    },

    data () {
      return {
        product: {
          id: null,
          coils: this.coils
        }
      }
    },

    computed: {
    },

    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/Products/EmptyProduct.vue